<template>
  <div>
    <div v-if="editFornecedor && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitFornecedor" v-if="!editFornecedor || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editFornecedor || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Tipo" prop="tipo_fornecedor" :rules="[$requiredChange]" key="tipo_fornecedor">
              <el-select v-model="dados.tipo_fornecedor">
                <el-option label="AGRICULTURA FAMILIAR" value="agricultura_familiar"></el-option>
                <el-option label="EMPRESA" value="empresa"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="CNPJ" prop="cnpj" key="cnpj">
              <el-input v-model="dados.cnpj" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Telefone" prop="telefone" key="telefone">
              <el-input v-model="dados.telefone" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Email" prop="email" key="email">
              <el-input v-model="dados.email" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Endereço" prop="endereco" key="endereco">
              <el-input v-model="dados.endereco" maxlength="191" v-on:blur="formatData('endereco')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-fornecedor" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editFornecedor: false,
    dados: {
      id: '',
      nome: '',
      cnpj: '',
      telefone: '',
      email: '',
      endereco: '',
      tipo_fornecedor: 'empresa',
      ativo: true
    }
  }),
  methods: {
    getFornecedorById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmitFornecedor () {
      document.getElementById("btn-fornecedor").focus()

      this.$refs.dados.validate((valid) => {
        if (valid) {
          window.eventBus.$emit('loading', true)

          if (this.editFornecedor) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitFornecedor')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitFornecedor')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatData (field) {
      if (!this.dados[field]) return false
      this.dados[field] = this.dados[field].toUpperCase()
      this.dados[field] = this.$removerAcentos(this.dados[field])
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getFornecedorById(value)
          this.editFornecedor = true
        }
      }
    }
  }
}
</script>

